import { AttributesMixin, define, Model, type } from "@type-r/models";
import { AssetStateIds } from "../../api/assetStateIds";
import { AssetType } from "../../api/assetType";
import { DateFilter, formatDateFilter } from "../../components/search-bar/filters/date-filter";
import { MultiSelectChipsAsyncFilter } from "../../components/search-bar/filters/multiselect-chips-async-filter";
import { TextFilter } from "../../components/search-bar/filters/text-filter";

const defaultSort = {
    attr: "createdOn",
    asc: false
};

export const SortOptions = {
    createdOn: 'Created On',
    updatedOn: 'Updated On'
}

export const InvoiceStateOptions = [
    {
        value: 0,
        label: 'All'
    },
    {
        value: AssetStateIds.Pending,
        label: 'Pending'
    },
    {
        value: AssetStateIds.Digitized,
        label: 'Digitized'
    }
]

export interface InvoicesFilters extends AttributesMixin<typeof InvoicesFilters> { }

@define
export class InvoicesFilters extends Model {
    static attributes = {
        filterAll: '',
        suppliers: type(MultiSelectChipsAsyncFilter),
        buyers: type(MultiSelectChipsAsyncFilter),
        invoiceNumber: type(TextFilter),
        faceValue: type(TextFilter),
        invoiceDate: type(DateFilter),
        invoiceDueDate: type(DateFilter),
        effectiveDate: type(DateFilter),
        sortBy: type(defaultSort),
        stateId: 0,
        importJobId: type(TextFilter),
        assetUid: type(TextFilter)
    }
    reset() {
        this.filterAll = '';
        this.suppliers.$.selected.set([] as any);
        this.buyers.$.selected.set([] as any);
        this.invoiceNumber.$.value.set('');
        this.faceValue.$.value.set('');
        this.invoiceDate.$.date.set(null);
        this.invoiceDueDate.$.date.set(null);
        this.effectiveDate.$.date.set(null);
        this.importJobId.$.value.set('');
        this.assetUid.$.value.set('');
    }
}